import { CONFIG } from '../../core/config';
import { ViewModel } from '../view-model';
import { InspectionPlanStatus } from './inspection-plan-status.enum';

export class InspectionPlan implements ViewModel {
  public readonly friendlyTypeNameSingular = 'inspectionPlan';
  readonly apiRoute: string = CONFIG.apiRoutes.inspectionPlan;

  inspectionPlanId: string;
  createdBy: string;
  creationDate: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
  orgTreeNodeModelRunId: string;
  inspectionPlanStatus: InspectionPlanStatus;

  public json(): any {
    return this;
  }

  public loadFromJson(data) {
    this.inspectionPlanId = data.inspectionPlanId;
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedDate = data.lastModifiedDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;
    this.inspectionPlanStatus = data.inspectionPlanStatus;
  }
}
